import { DocumentManager } from '../../RichTextEditor';
import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function usePostFormState() {
  return useAppState();
}

export function usePostFormActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((state) => ({
      ...state,
      postForm: {
        documentManager: new DocumentManager({ startDocumentComponentType: 'DocumentParagraph' }),
        postAttachment: null,
      },
    }));
  }

  // Bridges the editor helpers' setState API (which expects { documentManager } at the
  // top level) with AppContext's nested state shape ({ postForm: { documentManager } }).
  function setEditorState(updater) {
    dispatch((appState) => {
      const prevEditorState = {
        documentManager: appState.postForm.documentManager,
        feedbackMessage: appState.feedbackMessage,
        feedbackVariant: appState.feedbackVariant,
      };
      const nextEditorState = typeof updater === 'function' ? updater(prevEditorState) : updater;
      return {
        ...appState,
        postForm: {
          ...appState.postForm,
          documentManager: nextEditorState.documentManager,
          activeStyleTypes: nextEditorState.activeStyleTypes,
          activeFormat: nextEditorState.activeFormat,
          activeHref: nextEditorState.activeHref,
        },
        feedbackMessage: nextEditorState.feedbackMessage !== undefined ? nextEditorState.feedbackMessage : appState.feedbackMessage,
        feedbackVariant: nextEditorState.feedbackVariant !== undefined ? nextEditorState.feedbackVariant : appState.feedbackVariant,
      };
    });
  }

  function setPostAttachment(postAttachment) {
    dispatch((state) => ({
      ...state,
      postForm: {
        ...state.postForm,
        postAttachment,
      },
    }));
  }

  function onResponse(response) {
    dispatch((state) => ({ ...state, ...response }));
  }

  function onError(feedback) {
    dispatch((state) => ({ ...state, ...feedback }));
  }

  function clearFeedback() {
    dispatch((state) => ({
      ...state,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    setEditorState,
    setPostAttachment,
    onResponse,
    onError,
    clearFeedback,
  };
}
